import { render, staticRenderFns } from "./FollowerFormResourceSelection.vue?vue&type=template&id=6ed159bc&scoped=true&"
import script from "./FollowerFormResourceSelection.vue?vue&type=script&lang=js&"
export * from "./FollowerFormResourceSelection.vue?vue&type=script&lang=js&"
import style0 from "./FollowerFormResourceSelection.vue?vue&type=style&index=0&id=6ed159bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed159bc",
  null
  
)

export default component.exports